var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15457"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#1400FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.462 30.44V27.52C15.462 26.55 16.222 25.68 17.302 25.68C18.272 25.68 19.142 26.44 19.142 27.52V30.33C19.142 32.28 17.522 33.9 15.572 33.9C13.622 33.9 12.002 32.27 12.002 30.33V24.17C11.892 18.55 16.332 14 21.952 14C27.572 14 32.002 18.55 32.002 24.06V30.22C32.002 32.17 30.382 33.79 28.432 33.79C26.482 33.79 24.862 32.17 24.862 30.22V27.41C24.862 26.44 25.622 25.57 26.702 25.57C27.672 25.57 28.542 26.33 28.542 27.41V30.44",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.73205fcb7fa3d55cf239bbb7463ad34a.svg";
export { ForwardRef as ReactComponent };